export default __webpack_public_path__ + "static/media/BE_Research_Paper.337cc5df.pdf";